import { createContext, PropsWithChildren, useCallback, useContext } from "react"

import { useAppDispatch, useAppSelector } from "store/hooks"
import { mobileMenuOpenSelector, setVerticalMenuOpenMobile, verticalMenuOpenSelector } from "store/tempDataSlise"

import { useWindowResize } from "hooks/useWindowResize"

import { MenuItems, MobileOverlay, StyledNav } from "./styled"

const VerticalMenuContext = createContext<{ isOpen: boolean; closeMobileMenu: () => void }>({
  isOpen: false,
  closeMobileMenu: () => {},
})

export const useVerticalMenuContext = () => useContext(VerticalMenuContext)

export const VerticalMenu = ({ children }: PropsWithChildren) => {
  const dispatch = useAppDispatch()
  const desktopMenuOpen = useAppSelector(verticalMenuOpenSelector)
  const mobileMenuOpen = useAppSelector(mobileMenuOpenSelector)
  const isLargeScreen = useWindowResize()

  const isOpen = isLargeScreen ? desktopMenuOpen : mobileMenuOpen

  const closeMobileMenu = useCallback(() => {
    if (!isLargeScreen) {
      dispatch(setVerticalMenuOpenMobile(false))
    }
  }, [dispatch, isLargeScreen])

  return (
    <VerticalMenuContext.Provider value={{ isOpen, closeMobileMenu }}>
      <MobileOverlay $isOpen={mobileMenuOpen} onClick={closeMobileMenu} />
      <StyledNav $isOpen={isOpen}>
        <MenuItems>{children}</MenuItems>
      </StyledNav>
    </VerticalMenuContext.Provider>
  )
}
